export default "__VITE_ASSET__Ddqa$yKH__"